export default {
  ticketList: (state) => state.ticketList,
  chargeTicketList: (state) => state.chargeTicketList,
};
